<<template>
    <div>
      <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
        <div class="level">
      <div class="level-left">
        <h4 class="title is-4" v-show="employee.employeeName !== null">{{employee.employeeName}}'s Document</h4>
      </div>
      <div class="level-right">
        <router-link :to="{name: 'Edit Employee', params: {employeeId: this.$route.params.employeeId}}" class="button is-small is-info">View&nbsp;<span v-show="employee.employeeName !== null">{{employee.employeeName}}'s&nbsp;</span>profile</router-link>
        &nbsp;
        <router-link :to="{name: 'List Of Employees'}" class="button is-small">Go back to list</router-link>
      </div>
    </div>
    <hr />
    <div class="columns">
        <div class="column is-3">
          <div class="field">
            <label class="label is-small">Document Type or Note</label>
              <div class="control">
                <textarea v-model="employeeDocument.documentType" class="input is-small"></textarea>
                <input type="file" multiple @change="fileChange($event.target.files)" ref="documentInput" accept="image/*"/>
              </div>
            </div>
        </div>
    </div>
    <div style="clear:both"></div>
    <button :class="buttonSave" @click="saveDocument">Add</button> &nbsp;
    <button class="button is-small" @click="refreshTable">Refresh</button>
      <b-table :data="uploadedDocuments">
        <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" field="employeeIdNumber" label="Document ID">
          {{item.row.employeeDocumentId}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="type" label="Document Type">
          {{item.row.documentType}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="file" label="Image(s)">
          <span v-for="file in item.row.employeeDocumentDetails">
            <img :src="'data:image/jpeg;base64, '+ file.document" width="100" height="100" @click="viewImage(file.document)" style="cursor:pointer" /> &nbsp;
          </span>
        </b-table-column>
        <b-table-column field="type" label="">
        <button class="button is-small is-danger" @click="openDeleteModal(item.row.employeeDocumentId)">Remove</button>
      </b-table-column>
</template>
      </b-table>

      <div class="modal is-active" v-show="showViewImageModal">
          <div class="modal-background"></div>
          <div class="modal-card">
              <header class="modal-card-head">
              <p class="modal-card-title">View Selected Image</p>
              <button class="delete"  @click="cancel" aria-label="close"></button>
              </header>
              <section class="modal-card-body">
              <!-- Content ... -->
              <img :src="selectedImageForView" style="width:100%;height:auto"/>
              </section>
              <footer class="modal-card-foot" style="justify-content:flex-end">
              <!-- <button :class="buttonDelete">Yes</button> -->
              <button class="button is-small" @click="cancel">Close</button>
              </footer>
          </div>
        </div>
        <div class="modal is-active" v-show="showDeleteDocuModal">
          <div class="modal-background"></div>
          <div class="modal-card">
              <header class="modal-card-head">
              <p class="modal-card-title">Delete selected document info</p>
              <button class="delete"  @click="cancelDeleteDocu" aria-label="close"></button>
              </header>
              <section class="modal-card-body">
              <!-- Content ... -->
              Are you sure do you want to permanently delete this document?
              </section>
              <footer class="modal-card-foot" style="justify-content:flex-end">
              <button :class="buttonDelete" @click="deleteSelectedDocu">Yes</button>
              <button class="button is-small" @click="cancelDeleteDocu">Close</button>
              </footer>
          </div>
        </div>
    </div>
    
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    isLoading: false,
    showViewImageModal: false,
    showDeleteDocuModal: false,
    selectedImageForView: null,
    buttonDelete: appButton.isLoadingDanger(false),
    buttonSave: appButton.isLoadingSuccess(false),
    employeeDocument: {
      employeeDocumentId: 0,
      documentType: '',
      employeeId: 0
    },
    employeeDocumentFiles: new FormData(),
    uploadedDocuments: [],
    employeeDocumentId: 0,
    employee: {
      employeeName: null
    }
  }),
  created() {
    this.employeeDocument.employeeId = this.$route.params.employeeId
    if (this.employeeDocument.employeeId) {
      this.getUploadedDocumentByEmpId(this.employeeDocument.employeeId)
      this.getEmployeeById(this.employeeDocument.employeeId)
    }
  },
  methods: {
    fileChange(fileList) {
      for (let i = 0; i < fileList.length; i++) {
        this.employeeDocumentFiles.append(
          'documentFiles',
          fileList[i],
          fileList[i].name
        )
      }
    },
    refreshTable() {
      this.getUploadedDocumentByEmpId(this.$route.params.employeeId)
    },
    viewImage(imageByte) {
      this.showViewImageModal = true
      this.selectedImageForView = `data:image/jpeg;base64,${imageByte}`
    },
    openDeleteModal(id) {
      this.showDeleteDocuModal = true
      this.employeeDocumentId = id
    },
    cancel() {
      this.showViewImageModal = false
      this.selectedImageForView = ''
    },
    cancelDeleteDocu() {
      this.showDeleteDocuModal = false
      this.employeeDocumentId = 0
      this.buttonDelete = appButton.isLoadingDanger(false)
    },
    default() {
      this.employeeDocumentFiles = new FormData()
      this.$refs.documentInput.value = ''
      this.buttonSave = appButton.isLoadingSuccess(false)
      this.employeeDocument = {
        employeeDocumentId: 0,
        documentType: '',
        employeeId: this.$route.params.employeeId
      }
      this.getUploadedDocumentByEmpId(this.$route.params.employeeId)
    },
    deleteSelectedDocu() {
      this.buttonDelete = appButton.isLoadingDanger(true)
      axios
        .delete(`api/employees/uploaded-document/${this.employeeDocumentId}`)
        .then(response => {
          appToast.success(response.data)
          this.getUploadedDocumentByEmpId(this.$route.params.employeeId)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.cancelDeleteDocu()
        })
    },
    saveDocument() {
      if (!this.employeeDocument.documentType) {
        appToast.danger('Document type or note must have a value')
        return false
      }

      if (!this.$refs.documentInput.value) {
        appToast.danger('Please choose scanned image(s)')
        return false
      }

      this.buttonSave = appButton.isLoadingSuccess(true)
      if (this.employeeDocument)
        this.employeeDocumentFiles.append(
          'documentInfo',
          JSON.stringify(this.employeeDocument)
        )
      console.log(this.employeeDocumentFiles)
      axios
        .post(`api/employees/upload-document`, this.employeeDocumentFiles)
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => console.log(error))
        .then(() => {
          this.default()
        })
    },
    getEmployeeById(id) {
      this.isLoading = true
      axios
        .get(`api/employees/${id}`)
        .then(response => {
          this.employee = response.data
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isLoading = false
        })
    },
    getUploadedDocumentByEmpId(id) {
      this.isLoading = true
      axios
        .get(`api/employees/uploaded-document/${id}`)
        .then(response => {
          this.uploadedDocuments = response.data
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isLoading = false
        })
    }
  }
}
</script>